import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import SearchBox from "@/components/feature/SearchBox";

const NAV_ITEMS = [
  { label: "首页", to: "/" },
  { label: "分类", to: "/category" },
  { label: "专题", to: "/#features" },
  { label: "关于", to: "/about" },
  { label: "联系", to: "/contact" }
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b transition-colors ${
        scrolled ? "border-background-200 bg-background-50/95 backdrop-blur-md" : "border-transparent bg-background-50"
      }`}
    >
      <div className="mx-auto flex h-16 w-full items-center gap-4 px-4 md:px-6 lg:px-8">
        <Link to="/" className="flex shrink-0 items-center gap-2.5">
          <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-movie-2-line text-xl"></i>
          </span>
          <span className="leading-none">
            <span className="block font-heading text-lg font-extrabold tracking-tight text-foreground-950">
              亲吻姐姐
            </span>
            <span className="mt-0.5 block text-[11px] tracking-widest text-foreground-500">MOVIE · SERIES · ANALYSIS</span>
          </span>
        </Link>

        <nav className="ml-4 hidden items-center gap-1 lg:flex">
          {NAV_ITEMS.map((item) =>
            item.to === "/#features" ? (
              <Link
                key={item.label}
                to="/#features"
                className="cursor-pointer rounded-md px-3.5 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-700"
              >
                {item.label}
              </Link>
            ) : (
              <NavLink
                key={item.label}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `rounded-md px-3.5 py-2 text-sm font-medium transition-colors ${
                    isActive
                      ? "bg-primary-100 text-primary-700"
                      : "text-foreground-700 hover:bg-background-100 hover:text-primary-700"
                  }`
                }
              >
                {item.label}
              </NavLink>
            )
          )}
        </nav>

        <div className="ml-auto hidden w-full max-w-xs xl:block">
          <SearchBox />
        </div>

        <Link
          to="/contact"
          className="ml-auto hidden whitespace-nowrap rounded-md bg-accent-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-accent-600 lg:inline-flex xl:ml-2"
        >
          投稿反馈
        </Link>

        <button
          type="button"
          onClick={() => setMenuOpen((prev) => !prev)}
          aria-label="打开导航菜单"
          className="ml-auto flex h-10 w-10 shrink-0 items-center justify-center rounded-md border border-background-300 text-foreground-800 lg:hidden"
        >
          <i className={menuOpen ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 lg:hidden">
          <div className="px-4 py-4">
            <SearchBox />
            <nav className="mt-4 flex flex-col">
              {NAV_ITEMS.map((item) =>
                item.to === "/#features" ? (
                  <Link
                    key={item.label}
                    to="/#features"
                    className="cursor-pointer border-b border-background-100 py-3.5 text-base font-medium text-foreground-800"
                  >
                    {item.label}
                  </Link>
                ) : (
                  <NavLink
                    key={item.label}
                    to={item.to}
                    end={item.to === "/"}
                    className={({ isActive }) =>
                      `border-b border-background-100 py-3.5 text-base font-medium ${
                        isActive ? "text-primary-700" : "text-foreground-800"
                      }`
                    }
                  >
                    {item.label}
                  </NavLink>
                )
              )}
              <Link
                to="/contact"
                className="mt-4 inline-flex items-center justify-center rounded-md bg-accent-500 px-4 py-3 text-sm font-medium text-background-50"
              >
                投稿反馈
              </Link>
            </nav>
          </div>
        </div>
      )}
    </header>
  );
}